import type {
  ChanelActionType,
  IncomingMessagePayload,
  IWebSocketConnection,
  RepositoryWS,
  TradeWSUpdate
} from '../../index'
import { PrivateConnectionChannels, WebSocketConnectionManager } from "../../index";

export class TradeHistoryApiWs implements RepositoryWS<TradeWSUpdate> {
  private wsChannel = PrivateConnectionChannels['HISTORY']

  constructor(private wsManager: WebSocketConnectionManager) {
  }

  async subscribeToChannelsAction(
    actionName: ChanelActionType,
    cb: (trade: TradeWSUpdate) => void
  ): Promise<undefined | ReturnType<IWebSocketConnection['subscribeToChannelMessages']>> {
    const connection = await this.wsManager.getConnection('private')
    const unsubscribeChannel = connection.subscribeToChannelMessages(this.wsChannel)
    const unsubscribeHandler = connection.addChannelHandler(this.wsChannel, (data: IncomingMessagePayload<TradeWSUpdate>) => {
      if (data.type === actionName) {
        cb(data.data)
      }
    })

    this.unsubscribeChannel = unsubscribeChannel
    this.unsubscribeHandler = unsubscribeHandler

    return () => {
      unsubscribeHandler()
      unsubscribeChannel()
    }
  }

  public unsubscribeToChannel(): void {
    this.unsubscribeHandler()
    this.unsubscribeChannel()
  }

  private unsubscribeHandler: (() => void) = () => {
    throw new Error("Method not initialized.");
  }

  private unsubscribeChannel: (() => void) = () => {
    throw new Error("Method not initialized.");
  }
}
